<template>
  <div class="x2-2">
    <icon :bgProps="iconProps.bgProps" />
    <div class="text-10">
      <div class="instant-features-8 inter-bold-celeste-24px">
        <span class="inter-bold-celeste-24px">Arhivator </span><span class="inter-medium-celeste-24px">DMS</span>
      </div>
      <p class="duis-aute-irure-dolo-9 inter-normal-gull-gray-18px">
        <span class="inter-normal-gull-gray-18px"
          >sistem upravljanja <br />dokumentacijom u cloudu<br />automatizacija procesa<br />arhivska knjiga</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import Icon from "./Icon";
export default {
  name: "X2",
  components: {
    Icon,
  },
  props: ["iconProps"],
};
</script>

<style>
.x2-2,
.x2-3 {
  height: 230px;
  min-width: 326px;
  position: relative;
}

.text-10,
.text-11 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 150px;
  left: 0;
  position: absolute;
  top: 80px;
  width: 326px;
}

.instant-features-8,
.instant-features-9 {
  letter-spacing: -0.25px;
  line-height: 34px;
  margin-left: 1px;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: 251px;
}

.duis-aute-irure-dolo-9,
.duis-aute-irure-dolo-10 {
  letter-spacing: -0.25px;
  line-height: 27px;
  min-height: 108px;
  text-align: center;
  width: 326px;
}
</style>
